import { createFileRoute } from '@tanstack/react-router'

import { PageLayout } from '@/components/layout'

import { DeviceForm } from '@/features/outlet/components/device-form'

export const Route = createFileRoute('/_app/outlet/device/$id/update')({
  component: RouteComponent,
})

function RouteComponent() {
  const navigate = Route.useNavigate()
  const { id } = Route.useParams()
  return (
    <PageLayout>
      <DeviceForm
        mode='update'
        id={id}
        onBack={() => navigate({ to: '/outlet/device', replace: true })}
      />
    </PageLayout>
  )
}
